import { inject } from 'vue';
import { eventKey } from '../keys';

export function useEventInjection() {
    const eventInjection = inject(eventKey);
    if (!eventInjection) {
        throw new Error('event not properly injected');
    }
    return eventInjection;
}
